export const sendPostMessage = (type: string, data: Object, sendDataOnly: boolean = false) => {
    if (sendDataOnly) {
        parent.postMessage(data, '*');
    } else {
        const message = {
            type,
            data
        }

        parent.postMessage(JSON.stringify(message), '*');
    }
}